import axios from "axios";
import GetApiBaseUrl from "./envConfig";
import { Commons } from "../utilities";

const getTokenAndLanguage = () => {
    const doctor_access = JSON.parse(localStorage.getItem("doctor_access"));
    const patient_access = JSON.parse(localStorage.getItem("patient_access"));
    const admin_access = JSON.parse(localStorage.getItem("admin_access"));

    let token = null;
    let languageAbb = null;

    if (doctor_access && doctor_access.userType === Commons.userType.doctor) {
        token = doctor_access.token;
        languageAbb = doctor_access.languageAbb;
    }
    if (patient_access && patient_access.userType === Commons.userType.patient) {
        token = patient_access.token;
    }
    if (admin_access && admin_access.userType === Commons.userType.admin) {
        token = admin_access.token;
    }

    return { token, languageAbb };
};

const ApiService = axios.create({
    baseURL: GetApiBaseUrl(),
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    },
});

ApiService.interceptors.request.use(
    (config) => {
        const { token, languageAbb } = getTokenAndLanguage()

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (languageAbb) {
            config.headers.currentlanguage = languageAbb;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default ApiService;
